import React from "react";
import "./Attributes.css";
import attributeimage from "../metaverseassets/attributeimg.png";
import check from "../metaverseassets/check.png";

export default function Attributes() {
  return (
    <div id="metaverse-attributes" className="metaversemainclass">
      <div className="left">
        <h1 className="heading">
         Metaverse App Development for Web, Mobile, and VR Experiences
        </h1>
        <p>
          Metaverse applications enable users to access immersive environments across web, mobile, and VR devices. These applications are optimized for performance, real-time interaction, and intuitive navigation.
        </p>

        <ul>
          <li>
            <img src={check} alt="error" />
            <span>Web-based metaverse platforms</span>
          </li>
          <li>
            <img src={check} alt="error" />
            <span>Mobile metaverse applications</span>
          </li>
        <li>
            <img src={check} alt="error" />
            <span>VR headset integration</span>
          </li>
          <li>
            <img src={check} alt="error" />
            <span>Multi-device synchronization</span>
          </li>
        </ul>
      </div>
      <div className="right">
        <img src={attributeimage} alt="error" />
      </div>
    </div>
  );
}
